export default function PhoneIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 24 24"
        >
            <path
                fill="#FF7070"
                d="M16.75 1h-10c-1.103 0-2 .897-2 2v18c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V3c0-1.103-.897-2-2-2zm-10 20V3h10l.002 18H6.75z"
            ></path>
            <path fill="#FF7070" d="M11.75 20a1 1 0 100-2 1 1 0 000 2z"></path>
        </svg>
    );
}